export const RETURNING_USER_KEY = 'returning-user';

/**
 * Checks if the user is a returning customer.
 */
export function isReturningUser() {
    try {
        return !!window.localStorage.getItem(RETURNING_USER_KEY);
    } catch {
        return true;
    }
}
